import axios from 'axios';
import { env } from '../config/env';

export const apiClient = axios.create({
  baseURL: env.baseUrl || '/',
});

apiClient.interceptors.request.use((config) => {
  if (env.apiKey) {
    config.headers.ApiKey = env.apiKey;
  }

  return config;
});
